(() => {
  const selectors = {
    removeProductButton: '.js-cart__rowProductRemove',
    quantityButton: '.js-cart__rowProductQuantity',
    quantityButtonsWrapper: '.cart__rowProductQuantityButtons',
    quantityInput: '.cart__product-qty',
    cartSection: '.js-cart__wrapper',
    cartForm: '.js-cart-form',
    cartCountIcon: '.js-cart-link__bubble',
    cartCost: '.js-cart__totalCost',
    cartDescription: '.js-cart__totalDescription',
    giftSection: '.js-gift-with-discount',
    discountCode: '.js-discount-code',
    progressBar: '.progressBar',
    oldPrice: '.oldPrice',
    cartTotal: '#cartTotal',
    cartSubtotal: '.cart__totalSubtotalPrice',

    cartPopUp: '.cart-popup',
    cartCount: '.cart-count',
    cartCountVisibleClass: 'visible',

    dataID: '[name="id"]',
    removeGiftData: '[data-remove-gift]',

    quantityButtonPlusClass: 'js-cart__rowProductQuantityPlus',
    cartSectionEmptyClass: 'cart__wrapper--empty',
    cartFullWidthClass: 'cart__wrapper--fullWidth',
    cartCountIconVisibleClass: 'cart-link__bubble--visible',
    activeClass: 'active'
  }

  theme.getCart = async () => {
    try {
      const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartRes.json();

      return cartData;

    } catch (error) {
      console.error(error);
    }
  };

  theme.removeProduct = async (event) => {
    const target = event.currentTarget;
    if (target.dataset.bundle) {
      const cartItems = cartData.items;

      if (cartItems.length) {
        let removeProducts = { updates: {} };
  
        cartItems.forEach((item) => {
          if (item.properties._bundle == target.dataset.bundle) {
            removeProducts.updates[item.key] = 0;
          }
        });
  
        if (Object.keys(removeProducts.updates).length !== 0) {
          await theme.updateProduct(removeProducts)
        }
      };
    } else {
      const item = { 'line': +target.dataset.line, 'quantity': 0 };
      theme.changeProduct(item);
  
    }
  };

  theme.changeQuantity = async (event) => {
    const target = event.currentTarget;
    const quantityButtonsWrapper = target.closest(selectors.quantityButtonsWrapper);
    const currentQuantity = quantityButtonsWrapper.querySelector(selectors.quantityInput);
    const quantity = target.classList.contains(selectors.quantityButtonPlusClass) ? (+currentQuantity.value + 1) : (+currentQuantity.value - 1);
    const item = { 'line': +quantityButtonsWrapper.dataset.line, 'quantity': quantity };

    theme.changeProduct(item);
  };

  theme.changeProduct = async (item) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      });

      if (response.ok) {
        await theme.checkCartState();
        return response;
      }
    } catch (error) {
      console.error(error);
    }
  };

  theme.updateProduct = async (items) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
      });

      if (response.ok) {
        await theme.checkCartState();
        return response;
      }
    } catch (error) {
      console.error(error);
    }
  };

  theme.addProduct = async (items) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({'items': items})
      });

      if (response.ok) {
        await theme.checkCartState();
        return response;
      }
    } catch (error) {
      console.error(error);
    }
  };

  theme.updateCartData = async (cartSection, cartData) => {
    await theme.updateCartForm(cartSection, cartData);
    await theme.updateCartTotal(cartData);
    await theme.showGiftButton();
    await theme.initCartFormListener();
  };

  theme.updateGiftSection = async (giftSection) => {
    const currentGiftSection = document.querySelector(selectors.giftSection);

    if (currentGiftSection && giftSection) {
      currentGiftSection.innerHTML = giftSection.innerHTML;

      const discountCodeElements = document.querySelectorAll(selectors.discountCode);
      let discountObjects = [];

      discountCodeElements.forEach(function(element) {
        const discountObject = JSON.parse(element.textContent.trim());

        discountObjects.push(discountObject);
      });

      theme.gift_discounts_list = discountObjects;
    } else return;
  };

  theme.checkCartState = async () => {
    let cartSection, giftSection;

    try {
      const cartRes = await fetch(window.Shopify.routes.root + 'cart?timestamp=' + Date.now());
      const cartHtml = await cartRes.text();
      const tempElement = document.createElement('div');

      tempElement.innerHTML = cartHtml;
      cartSection = tempElement.querySelector(selectors.cartSection);
      giftSection = tempElement.querySelector(selectors.giftSection);

    } catch (error) {
      console.error(error);
    } finally {
      const cartData = await theme.getCart();

      if (cartSection) {
        if (cartSection.classList.contains(selectors.cartSectionEmptyClass)) {
          await theme.showEmptyCart(cartSection);
        } else {
          await theme.updateCartData(cartSection, cartData);
        }
      }

      if (giftSection) {
        theme.updateGiftSection(giftSection);
      }

      theme.changeCartIconCount(cartData);
    }
  };

  theme.showEmptyCart = async (cartSection) => {
    const currentCartSection = document.querySelector(selectors.cartSection);

    currentCartSection.classList.add(selectors.cartFullWidthClass);
    currentCartSection.innerHTML = cartSection.innerHTML;
  };

  theme.changeCartIconCount = async (cartData) => {
    const cartCountIcons = document.querySelectorAll(selectors.cartCountIcon);
    const count = cartData.item_count;

    cartCountIcons.forEach((cartCount) => {
      if (count > 0) {
        cartCount.innerText = count;
        cartCount.classList.add(selectors.cartCountIconVisibleClass);
      } else {
        cartCount.innerText = '';
        cartCount.classList.remove(selectors.cartCountIconVisibleClass);
      }
    });
  };

  theme.updateCartForm = async (cartSection, cartData) => {
    const currentCartForm = document.querySelector(selectors.cartForm);
    const updatedCartForm = cartSection.querySelector(selectors.cartForm);

    if (currentCartForm && updatedCartForm) {
      currentCartForm.innerHTML = updatedCartForm.innerHTML;

      if (document.querySelector(selectors.progressBar)) {
        await theme.progressBarGifts(cartData);
      };

      await theme.checkGiftsToRemove();
      theme.checkProgressBarGiftsCount(cartData);
    } else return;
  };

  theme.updateCartTotal = async (cartData) => {
    const originalPrice = document.querySelector(selectors.oldPrice);
    const totalPrice = document.querySelector(selectors.cartTotal);
    const subtotalPrice = document.querySelector(selectors.cartSubtotal);
    const isDiscount = cartData.original_total_price > cartData.total_price;
    const moneyFormat = theme.strings.moneyFormat;

    subtotalPrice.innerText = theme.Currency.formatMoney(cartData.total_price, moneyFormat);
    originalPrice.innerText = theme.Currency.formatMoney(cartData.original_total_price, moneyFormat);
    totalPrice.innerText = theme.Currency.formatMoney(cartData.total_price, moneyFormat);
    isDiscount ? originalPrice.classList.add(selectors.activeClass) : originalPrice.classList.remove(selectors.activeClass);
    isDiscount ? totalPrice.classList.add(selectors.activeClass) : totalPrice.classList.remove(selectors.activeClass);
  };

  theme.checkGiftsToRemove = async () => {
    cartData = await theme.getCart();

    const removeGiftButton = document.querySelector(selectors.removeGiftData);

    if (removeGiftButton) {
      if (cartData.items[+removeGiftButton.dataset.line - 1]) {
        if (removeGiftButton.dataset.key === cartData.items[+removeGiftButton.dataset.line - 1].key) {
          const item = {'line': +removeGiftButton.dataset.line, 'quantity': 0};

          theme.changeProduct(item);
        }
      }
    }
  };

  theme.initCartFormListener = () => {
    const removeLinks = document.querySelectorAll(selectors.removeProductButton);
    const quantityButton = document.querySelectorAll(selectors.quantityButton);

    removeLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        theme.removeProduct(event);
      });
    });

    quantityButton.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        theme.changeQuantity(event);
      });
    });
  };

  theme.checkProgressBarGiftsCount = async (cartData) => {
    const cartItems = cartData.items;

    if (cartItems.length) {
      let updateGifts = { updates: {} };

      cartItems.forEach((gift) => {
        if (gift.properties._block_id && gift.quantity != 1) {
          updateGifts.updates[gift.key] = 1;
        }
      });

      if (Object.keys(updateGifts.updates).length !== 0) {
        await theme.updateProduct(updateGifts)
      }
    };
  };
  class ButtonAddToCart extends HTMLElement {
      constructor() {
          super();
      }

      connectedCallback() {
        this.addEventListener('click', this.addToCart);
      };

      disconnectedCallback() {
        this.removeEventListener('click', this.addToCart);
      };

    async addToCart(event) {
      event.preventDefault();

      const currentForm = this;
      const currentVariantID = currentForm.querySelector(selectors.dataID).value;
      const cartPopUp = document.querySelector(selectors.cartPopUp);

      try {
        const addToCartPromise = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: currentVariantID,
              quantity: 1
            }]
          }),
        });

        if (!addToCartPromise.ok) {
          const errorObject = await addToCartPromise.json();
          throw new Error(errorObject.description);
        }

        const numberCounts = document.querySelectorAll(selectors.cartCount);

        numberCounts.forEach((count) => {
          count.innerText = +count.innerText + 1;
          count.classList.add(selectors.cartCountVisibleClass);
        });

        if (cartPopUp) {
          window.showCartPopup();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }
  };

  customElements.define('button-add-to-cart', ButtonAddToCart);

  theme.initCartFormListener();
  theme.checkGiftsToRemove();
})();
